import React, { useState, useCallback } from "react";

import { Cached } from "@mui/icons-material";
import { Box, Button, IconButton, Typography } from "@mui/material";
import debounce from "lodash.debounce";
// import debounce from "lodash.debounce";

import {
  SearchInput,
  CustomDatePicker,
  PassingCriteriaDialog,
  FilterDropDown,
} from "../../common";
import { interview_stages } from "../../static/data";

/* ============================================================================
<InterviewResultsCandidatesTableHeader/>
============================================================================= */
const InterviewResultsCandidatesTableHeader = ({
  onReload,
  filters,
  onSearch,
  onFilterChange,
  onReset,
}) => {
  const [searchText, setSearchText] = useState("");

  const debounceFn = useCallback(debounce(onSearch, 500), []);

  const _handleSearchTextChange = (value) => {
    debounceFn(value);
    setSearchText(value);
  };

  return (
    <Box
      display="flex"
      flexDirection={{ xs: "column", md: "row" }}
      p={1.5}
      justifyContent="space-between"
      alignItems="center"
      gap={1}
    >
      <Box display="flex" alignItems="center" gap={2}>
        <Typography fontSize="20px" fontWeight={700}>
          Candidate
        </Typography>
        <IconButton
          size="small"
          sx={{ border: "1px solid #B1B1B1" }}
          onClick={onReload}
        >
          <Cached sx={{ fontSize: 18, color: "#B1B1B1" }} />
        </IconButton>
      </Box>
      <Box
        flex={1}
        display="flex"
        width="100%"
        flexWrap="wrap"
        justifyContent="flex-end"
        alignItems="center"
        gap={1}
      >
        <Button
          variant="outlined"
          onClick={onReset}
          sx={{
            px: { xs: 2, md: 4 },
            py: 1.4,
            borderRadius: "7px",
            color: "text.secondary",
            borderColor: "divider",
            fontStyle: "Outfit",
          }}
        >
          Reset Filters
        </Button>
        <CustomDatePicker
          start={filters?.startDate}
          end={filters?.endDate}
          onChange={onFilterChange}
        />
        <PassingCriteriaDialog
          value={filters}
          onChange={onFilterChange}
          showInterview
        />
        <FilterDropDown
          value={filters?.stage}
          data={interview_stages}
          placeholder="Stage"
          onChange={(newStage) => onFilterChange({ stage: newStage })}
        />
        <SearchInput
          value={searchText}
          onChange={_handleSearchTextChange}
          placeholder="Search"
          containerStyles={{ width: "100%", minWidth: "120px", flex: 0.2 }}
        />
      </Box>
    </Box>
  );
};

/* Export
============================================================================= */
export default InterviewResultsCandidatesTableHeader;
